<div *ngIf="(profileInfo$ | async) as profile; else loading" class="profile-information block">
  <div class="d-flex flex-column align-items-center profile-top">
    <app-avatar [src]="profile.icon" [placeholder]="profile | initials" class="ava"> </app-avatar>

    <app-user-name [profile]="profile"></app-user-name>
    <div *ngIf="profile.type === 'student'" class="profile-years">{{profile.student?.born | yearsFromDate}}</div>
    <div *ngIf="isShowConnectMessage$ | async" class="profile-actions d-flex">
      <button
        *ngIf="!profile.is_friend && !profile.friend_request"
        class="action d-flex align-items-center justify-content-center"
        (click)="onProfileConnect(profile.id); false"
      >
        <span class="icon">
          <svg viewBox="0 0 20 20">
            <use href="#friends"></use>
          </svg>
        </span>
        <div>Connect</div>
      </button>
      <button
        *ngIf="profile.is_friend || profile.friend_request"
        class="action d-flex align-items-center justify-content-center"
        (click)="onProfileDisconnect(profile.id); false"
      >
        <span class="icon">
          <svg viewBox="0 0 20 20">
            <use href="#friends"></use>
          </svg>
        </span>
        <div>Disconnect</div>
      </button>
      <button
        class="action d-flex align-items-center justify-content-center"
        (click)="openMessageDialog(profile); false"
      >
        <span class="icon">
          <svg viewBox="0 0 20 20">
            <use href="#message"></use>
          </svg>
        </span>
        <div>Message</div>
      </button>
    </div>
  </div>
  <div class="enumerations">
    <div class="enumeration-item d-flex">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#location" />
        </svg>
      </div>
      <span>
        <app-search-link [value]="profile.location?.city?.name" [topic]="'location'">
          <span> {{ profile.location?.city?.name }}</span>,
          <span>{{ profile.location?.country?.name }}</span>
        </app-search-link>
      </span>
    </div>
    <div *ngIf="profile.type === 'teacher'" class="enumeration-item d-flex">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#cap" />
        </svg>
      </div>
      <span>
        <span>{{profile?.teacher?.member}}</span>
      </span>
    </div>
    <div class="enumeration-item d-flex" *ngIf="profile.type === 'teacher'">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#cap" />
        </svg>
      </div>
      <span>
        <app-search-link [value]="profile.teacher?.currentschool?.name" [topic]="'school'">
          <span> {{profile.teacher?.currentschool?.name}}</span>
        </app-search-link>
      </span>
    </div>
    <div *ngIf="profile.type === 'student'" class="enumeration-item d-flex">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#cap" />
        </svg>
      </div>
      <span>
        <span class="mr-1">Student at</span>
        <app-search-link [value]="profile.id" [topic]="'org'">
          <span>{{profile.student?.currentschool?.name}}</span>
        </app-search-link>
      </span>
    </div>
    <div *ngFor="let school of profile.previosschool" class="enumeration-item d-flex">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#cap" />
        </svg>
      </div>
      <span>
        Past education
        <app-search-link [value]="school.name" [topic]="'school'">
          <span>{{school.name}}</span>
        </app-search-link>
      </span>
    </div>
  </div>
  <div
    *ngIf="(profile.type === 'student' || profile.type === 'teacher') && (!!profile.student?.about_me || !!profile.teacher?.about_me)"
    class="about-block"
  >
    <div class="title">About me</div>
    <div> {{(profile.type === 'student') ? profile.student?.about_me : profile.teacher?.about_me}} </div>
  </div>
  <button
    class="toggle-profile-information"
    *ngIf="profile.scores?.length || profile.languages?.length || profile.honorsandavards?.length || profile.otherexperience?.length
          || profile.interest?.length ||  profile.afterschool?.length || profile.certifications?.length || profile.wants?.length || profile.have?.length
          || profile.associations?.length || profile.associations?.length || profile.evolutions?.length || profile.specialization?.length
          "
    (click)="hideInfo=!hideInfo"
    >{{hideInfo? 'Show' : 'Hide'}} full information
  </button>
  <ng-template [ngIf]="!hideInfo">
    <ng-container *ngIf="profile.type === 'org'">
      <div class="enumerations">
        <div class="enumeration-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 20 20">
              <use href="#cap" />
            </svg>
          </div>
          <span> {{profile.org?.member}} </span>
        </div>
      </div>
      <div class="about-block">
        <div class="title">About us</div>
        <div> {{profile.org?.about}} </div>
      </div>
    </ng-container>

    <ng-container *ngIf="profile.type === 'teacher'">
      <div *ngIf="profile.specialization.length" class="enumerations border-bottom">
        <div class="title">Subjects/Expertise</div>
        <div class="boxes d-flex flex-wrap">
          <div *ngFor="let item of profile.specialization" class="enumeration-box">
            <app-search-link [value]="item.name" [topic]="'specialization'">
              <span>{{item.name}}</span>
            </app-search-link>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="profile.otherexperience.length" class="enumerations border-bottom">
        <div class="title">Other Experience</div>
        <div *ngFor="let item of profile.otherexperience" class="enumeration-item d-flex">
          <span>
            <app-search-link [value]="item.reference.name" [topic]="''">
              <span>{{item.reference.name}}</span>
            </app-search-link>
            <span> @ </span>
            <app-search-link [value]="item.body.name" [topic]="''">
              <span>{{item.body.name}}</span>
            </app-search-link>
          </span>
        </div>
      </div> -->
      <!--      <div *ngIf="profile.evolutions.length" class="enumerations border-bottom">-->
      <!--        <div class="title">Education</div>-->
      <!--        <div *ngFor="let item of profile.evolutions" class="enumeration-item d-flex">-->
      <!--          <app-search-link [value]="item.reference.name" [topic]="''">-->
      <!--            <span>{{item.reference.name}}</span>-->
      <!--          </app-search-link>-->
      <!--          <span class="ml-1 mr-1"> @ </span>-->
      <!--          <app-search-link [value]="item.body.name" [topic]="''">-->
      <!--            <span>{{item.body.name}}</span>-->
      <!--          </app-search-link>-->
      <!--        </div>-->
      <!--      </div>-->
      <div *ngIf="profile.evolutions?.length" class="enumerations border-bottom">
        <div class="title">Education</div>
        <div *ngFor="let item of profile.evolutions" class="enumeration-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 20 20">
              <use href="#work" />
            </svg>
          </div>
          <span>
            <app-search-link [value]="item.reference.name" [topic]="''">
              <span>{{item.reference.name}}</span>
            </app-search-link>
            <span> @ </span>
            <app-search-link [value]="item.body.name" [topic]="''">
              <span>{{item.body.name}}</span>
            </app-search-link>
          </span>
        </div>
      </div>
      <div *ngIf="profile.associations.length" class="enumerations border-bottom">
        <div class="title">Associations</div>
        <div *ngFor="let item of profile.associations" class="enumeration-item d-flex">
          <app-search-link [value]="item.name" [topic]="'associations'">
            <span>{{item.name}}</span>
          </app-search-link>
        </div>
      </div>
      <div *ngIf="profile.have.length" class="enumerations border-bottom">
        <div class="title">Haves</div>
        <div class="boxes d-flex flex-wrap">
          <div *ngFor="let item of profile.have" class="enumeration-box">
            <app-search-link [value]="item.name" [topic]="'have'">
              <span>{{item.name}}</span>
            </app-search-link>
          </div>
        </div>
      </div>
      <div *ngIf="profile.wants.length" class="enumerations border-bottom">
        <div class="title">Wants</div>
        <div class="boxes d-flex flex-wrap">
          <div *ngFor="let item of profile.wants" class="enumeration-box">
            <app-search-link [value]="item.name" [topic]="'wants'">
              <span>{{item.name}}</span>
            </app-search-link>
          </div>
        </div>
      </div>
      <div *ngIf="profile.certifications.length" class="enumerations border-bottom">
        <div class="title">Certifications</div>
        <div *ngFor="let item of profile.certifications" class="enumeration-item d-flex">
          <app-search-link [value]="item.name" [topic]="'certifications'">
            <span>{{item.name}}</span>
          </app-search-link>
        </div>
      </div>
    </ng-container>

    <div *ngIf="profile.afterschool && profile.afterschool.length" class="enumerations border-bottom">
      <div class="title">Extra-curricular</div>
      <div *ngFor="let item of profile.afterschool" class="enumeration-item d-flex">
        <div class="icon">
          <svg viewBox="0 0 20 20">
            <use href="#startup" />
          </svg>
        </div>
        <span>
          <app-search-link [value]="item.reference.name" [topic]="''">
            <span>{{item.reference.name}}</span>
          </app-search-link>
          <span> @ </span>
          <app-search-link [value]="item.body.name" [topic]="''">
            <span>{{item.body.name}}</span>
          </app-search-link>
        </span>
      </div>
    </div>
    <div *ngIf="profile.interest?.length" class="enumerations border-bottom">
      <div class="title">Interests</div>
      <div class="boxes d-flex flex-wrap">
        <div *ngFor="let item of profile.interest" class="enumeration-box">
          <app-search-link [value]="item.name" [topic]="''">
            <span>{{item.name}}</span>
          </app-search-link>
        </div>
      </div>
    </div>
    <div *ngIf="profile.otherexperience?.length" class="enumerations border-bottom">
      <div class="title">Other Experience</div>
      <div *ngFor="let item of profile.otherexperience" class="enumeration-item d-flex">
        <div class="icon">
          <svg viewBox="0 0 20 20">
            <use href="#work" />
          </svg>
        </div>
        <span>
          <app-search-link [value]="item.reference.name" [topic]="''">
            <span>{{item.reference.name}}</span>
          </app-search-link>
          <span> @ </span>
          <app-search-link [value]="item.body.name" [topic]="''">
            <span>{{item.body.name}}</span>
          </app-search-link>
        </span>
      </div>
    </div>
    <div *ngIf="profile.honorsandavards?.length" class="enumerations border-bottom">
      <div class="title">Honors & Awards</div>
      <div *ngFor="let item of profile.honorsandavards" class="enumeration-item d-flex">
        <div class="icon">
          <svg viewBox="0 0 20 20">
            <use href="#medal" />
          </svg>
        </div>
        <span>
          <app-search-link [value]="item.reference.name" [topic]="''">
            <span>{{item.reference.name}}</span>
          </app-search-link>
          <span> @ </span>
          <app-search-link [value]="item.body.name" [topic]="''">
            <span>{{item.body.name}}</span>
          </app-search-link>
        </span>
      </div>
    </div>
    <div *ngIf="profile.type === 'student' && profile.language?.length" class="enumerations border-bottom">
      <div class="title">Languages</div>
      <div class="boxes d-flex flex-wrap">
        <div *ngFor="let item of profile.language" class="enumeration-box">
          <app-search-link [value]="item.name" [topic]="''">
            <span>{{item.name}}</span>
          </app-search-link>
        </div>
      </div>
    </div>
    <div *ngIf="profile.type === 'student'  && profile.scores?.length" class="enumerations">
      <div class="title">Test Scores</div>
      <div class="boxes d-flex flex-wrap">
        <div
          *ngFor="let score of profile.scores"
          class="enumeration-box"
          (click)="searchByTopic($event, 'tests', score.scores.name)"
        >
          <app-search-link [value]="score.scores.name" [topic]="''">
            <span>{{score.scores.name}}</span>
          </app-search-link>
          <span> : </span>
          <app-search-link [value]="score.val" [topic]="''">
            <span>{{score.val}}</span>
          </app-search-link>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<ng-template #loading>
  <app-loader-2></app-loader-2>
</ng-template>
